export function captureMsclkid(): void {
  try {
    const match = window.location.search.match(/[?&]msclkid=([^&#]+)/);
    if (!match) return;
    const value = decodeURIComponent(match[1]);
    if (!value) return;
    const existing = document.cookie.match(/(?:^|; )_uetmsclkid=([^;]*)/);
    if (existing && decodeURIComponent(existing[1]) === value) return;
    const domain =
      window.location.hostname.endsWith("docuclipper.com")
        ? "; domain=.docuclipper.com"
        : "";
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie =
      "_uetmsclkid=" +
      encodeURIComponent(value) +
      "; path=/" +
      domain +
      "; max-age=7776000; SameSite=Lax" +
      secure;
  } catch (e) {
    /* noop */
  }
}
